import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {PublicNs} from "@shared/types/public.namespace.ts";
import {usePublicProjectStore} from "@domains/publish/project/stores";


export const publicPageAuthGuard = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
): Promise<void> => {

  const projectId = to.params.projectId;
  const token = to.params.token

  if (!projectId || !token) {
    next({name: PublicNs.PublicRouteEnums.ERROR})
  }

  const publicProjectStore = usePublicProjectStore();
  publicProjectStore.checkToken(projectId as string, token as string)
  .then(() => {
    next();
  })
  .catch((error) => {
    let errorMessage = '';
    if (error && error.response && error.response.data && error.response.data.message) {
      errorMessage = error.response.data.message;
    }
    next({name: PublicNs.PublicRouteEnums.ERROR, params: {message: errorMessage}});
  });

};
